/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetAllWithdrawalRequestsOptions,
  GetAllWithdrawalRequestsResponses,
} from '../types/GetAllWithdrawalRequests'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get all withdrawal requests
 * {@link /v1/ledger/withdraw/requests}
 */
export function getAllWithdrawalRequests<ThrowOnError extends boolean = true>(
  options: Options<GetAllWithdrawalRequestsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetAllWithdrawalRequestsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/withdraw/requests',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetAllWithdrawalRequestsResponses, ThrowOnError>>,
  )
}
